import { render, staticRenderFns } from "./taxonomy_list.vue?vue&type=template&id=5e00125e&"
import script from "./taxonomy_list.vue?vue&type=script&lang=js&"
export * from "./taxonomy_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports